import { useEffect } from 'react';

import { common } from 'app/translations/dictionary';

export const useTitle = (title: string) => {
  useEffect(() => {
    document.title = `${common.absoluteTranslation} ${title}`;
  }, [title]);
};
